import { NgModule, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { HomeComponent } from './general-components/home/home.component';
import { ProfileComponent } from './general-components/profile/profile.component';
import { SuppliersComponent } from './service-components/specials/suppliers/suppliers.component';
import { ReturnFailuresComponent } from './service-components/returns/return-failures/return-failures.component';
import { DispatchFailuresComponent } from './service-components/dispatches/dispatch-failures.component';
import { OrderShipmentInfoComponent } from './service-components/order-shipment-info/order-shipment-info.component';
import { InvoiceSearchComponent } from './service-components/invoice-search/invoice-search.component';
import { PaymentTermsCheckerComponent } from './service-components/check-payment-terms/check-payment-terms.component';
import { PaymentTermsCustomersComponent } from './service-components/check-payment-terms-customers/check-payment-terms-customers.component';
import { MancosToCheckUpOnComponent } from './service-components/mancos/mancos-to-check-up-on/mancos-to-check-up-on.component';
import { NewMancoComponent } from './service-components/mancos/new-manco/new-manco.component';
import { SalesorderOverviewComponent } from './service-components/salesorders/salesorder-overview/salesorder-overview.component';
import { NewSalesorderComponent } from './service-components/salesorders/new-salesorder/new-salesorder.component';
import { SOSEmailKrampComponent } from './service-components/sos-email/kramp/sos-email-kramp.component';
import { SOSEmailINDIComponent } from './service-components/sos-email/indi/sos-email-indi.component';
import { SOSEmailForOrdersWithoutResponseComponent } from './service-components/sos-email/indi-no-response/sos-email-indi-no-response.component';
import { KrampSpecialsComponent } from './service-components/specials/kramp-specials/kramp-specials.component';
import { FestoSpecialsComponent } from './service-components/specials/festo-specials/festo-specials.component';
import { TUSpecialsComponent } from './service-components/specials/tu-specials/tu-specials.component';
import { INDISpecialsComponent } from './service-components/specials/indi-specials/indi-specials.component';
import { PriceCheckerComponent } from './service-components/price-checker/price-checker.component';
import { ReturnsComponent } from './service-components/returns/returns/returns.component';
import { KrampShippingAddressesComponent } from './service-components/kramp-shipping-addresses/kramp-shipping-addresses.component';
import { ScsnCustomersComponent } from './service-components/scsn-customers/scsn-customers.component';
import { BlindSalesorderComponent } from './service-components/salesorders/blind-salesorder/blind-salesorder.component';
import { BlindCancellationComponent } from './service-components/order-history/blind-cancellation-update/blind-cancellation-update.component';
import { ProductImportFlowControlComponent } from './service-components/products/import-flow-control/product-import-flow-control/product-import-flow-control.component';
import { ProductImportStatusComponent } from './service-components/products/import-reports/product-import-status/product-import-status.component';
import { ProductImportAreaHistoryComponent } from './service-components/products/import-reports/product-import-area-history/product-import-area-history.component';
import { KrampPriceExportFlowControlComponent } from './service-components/pricing/kramp-price-export-flow-control/kramp-price-export-flow-control.component';
import { ProductDownloadsComponent } from './service-components/products/product-downloads/product-downloads.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },

  { path: 'profiel', component: ProfileComponent, canActivate: [AuthGuard] },
  {
    path: 'leveranciers',
    component: SuppliersComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'product-import/flow-control',
    component: ProductImportFlowControlComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'product-import/status',
    component: ProductImportStatusComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'product-import/status/:code',
    component: ProductImportAreaHistoryComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'kramp-pricing/export/control',
    component: KrampPriceExportFlowControlComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'retour-uitval',
    component: ReturnFailuresComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'retouren',
    component: ReturnsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'dispatches',
    component: DispatchFailuresComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'zending-info',
    component: OrderShipmentInfoComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'factuur-zoeken',
    component: InvoiceSearchComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'specials-kramp',
    component: KrampSpecialsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'specials-festo',
    component: FestoSpecialsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'specials-tu',
    component: TUSpecialsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'specials-indi',
    component: INDISpecialsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'betaaltermijnen-checken',
    component: PaymentTermsCheckerComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'betaaltermijnen-klanten',
    component: PaymentTermsCustomersComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'price-checker',
    component: PriceCheckerComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'mancos/mancos-to-check-up-on',
    component: MancosToCheckUpOnComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'mancos/mancos-to-check-up-on?filter=OpenMancosWithKrampReturnNumber',
    component: MancosToCheckUpOnComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'mancos/new-manco',
    component: NewMancoComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'verkooporders/verkooporder-overzicht',
    component: SalesorderOverviewComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'verkooporders/nieuwe-verkooporder',
    component: NewSalesorderComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'verkooporders/blinde-verkooporder',
    component: BlindSalesorderComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'order-history/blinde-annuleringsaanpassing/:customerNumber/:orderNumber/:orderPosNumber',
    component: BlindCancellationComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'sos-email-kramp',
    component: SOSEmailKrampComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'sos-email-indi',
    component: SOSEmailINDIComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'sos-email-no-response',
    component: SOSEmailForOrdersWithoutResponseComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'kramp-verzend-adressen',
    component: KrampShippingAddressesComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'scsn-klanten',
    component: ScsnCustomersComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  {
    path: 'product-downloads',
    component: ProductDownloadsComponent,
    canActivate: [
      (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state),
    ],
  },
  { path: '', component: HomeComponent }, // these need to be at the end
  { path: '**', redirectTo: 'home' }, // these need to be at the end
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
